import { trimNameForLabel } from './labels';

export function prepareSpinningWheelDOM(wheelTitle) {
	const canvas = $(`<canvas class="notification-spinning-wheel-canvas">
	</canvas>`);
	const wheelCanvas = $(`<canvas class="notification-spinning-wheel-canvas-hidden">
	</canvas>`); // off screen canvas is not fully supported in older browsers, and is missing fillText in newest Chrome
	const outerRimCanvas = $(`<canvas class="notification-spinning-wheel-canvas-hidden">
	</canvas>`);
	const notification = $('<div class="notification" />');
	
	notification.append($('<div class="overlay"></div>'));

	notification.append(canvas);
	notification.append(wheelCanvas);
	notification.append(outerRimCanvas);

	const canvases = {
		mainCanvas: canvas[0],
		wheelCanvas: wheelCanvas[0],
		outerRimCanvas: outerRimCanvas[0]
	};

	return {
		notification, 
		canvases,
	};
}

export function showHighlight(text) {
	const selected = $(`<span class="notification-spinning-wheel-highlight">
	</span>`);
	selected.text(trimNameForLabel(text));
	return selected;
}
